export const APP_VERSION = "3.0.0";

function canonicalize(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(canonicalize);
  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value as Record<string, unknown>)
        .filter(([key]) => !["lastAnalysis", "lastVerification"].includes(key))
        .sort(([left], [right]) => left.localeCompare(right))
        .map(([key, child]) => [key, canonicalize(child)]),
    );
  }
  return value;
}

export function projectChecksum(project: unknown): string {
  const text = JSON.stringify(canonicalize(project));
  let hash = 0x811c9dc5;
  for (let index = 0; index < text.length; index += 1) {
    hash ^= text.charCodeAt(index);
    hash = Math.imul(hash, 0x01000193);
  }
  return `FNV1A-${(hash >>> 0).toString(16).padStart(8, "0").toUpperCase()}`;
}

export interface ReportMetadata {
  version: string;
  checksum: string;
  generatedAt: string;
  standards: string[];
  assumptions: string[];
}

export function createReportMetadata(project: Record<string, any>): ReportMetadata {
  const method = project.treatment?.method;
  const standards = ["TCCS 41:2022/TCĐBVN + Sửa đổi 1:2022"];
  if (method === "pvd" || method === "vacuum_pvd") standards.push("TCVN 9355:2012");
  if (method === "cdm") standards.push("TCVN 9403:2012");
  const assumptions = [
    project.foundation?.drainage === "double" ? "Thoát nước cố kết hai mặt." : "Thoát nước cố kết một mặt.",
    project.foundation?.shearMode === "drained" ? "Phân tích sức kháng cắt hữu hiệu." : "Phân tích không thoát nước, φu = 0.",
    `Hệ số hiệu chỉnh độ lún m = ${project.foundation?.mFactor ?? "—"}.`,
    "Kết quả là tính toán sơ bộ và phải được đối chứng trước khi dùng cho hồ sơ thiết kế.",
  ];
  return {
    version: APP_VERSION,
    checksum: projectChecksum(project),
    generatedAt: new Date().toISOString(),
    standards,
    assumptions,
  };
}
